import React, { ReactNode } from "react";
import styles from "./VisuallyHidden.module.scss";

const VisuallyHidden = ({ children }: { children: ReactNode }) => (
  <div className={styles.root}>{children}</div>
);

export default VisuallyHidden;
